import { ToolTip } from "./client";
import { useStoreContext } from "@components/store/provider";

import { isValidHexCode } from "@stadium/helpers";
import { pluralizeWord } from "@stadium/helpers/string";

import productstyles from "./product-tile.module.scss";

const defaultArr = [];
const DEFAULT_COLORS_VISIBLE_COUNT = 5;

const ProductColorPills = ({
  colors = defaultArr,
  totalColorsCount = 0,
  colorsVisibleCount = DEFAULT_COLORS_VISIBLE_COUNT,
  containerClass = "",
}) => {
  const { isNewSwagmagicHost } = useStoreContext();
  const validColors = colors.filter((color) => isValidHexCode(color.value));
  const colorsCount = validColors.length;
  const invalidCount = totalColorsCount - colorsCount;
  const invisibleColorsCount =
    colorsCount > colorsVisibleCount
      ? colorsCount - colorsVisibleCount + invalidCount
      : invalidCount;
  const isAllInvisible = invisibleColorsCount > 0 && invisibleColorsCount === totalColorsCount;

  const renderOtherColorsCount = () => {
    if (invisibleColorsCount <= 0) return "";
    if (!isAllInvisible) {
      return (
        <span className={`${productstyles.colorqty} remainingQty`}>+{invisibleColorsCount}</span>
      );
    }
    return (
      <span className={`${productstyles.onlyNamedColorsText} onlyColorText`}>
        {invisibleColorsCount} {pluralizeWord("color", { count: invisibleColorsCount })} AVAILABLE
      </span>
    );
  };

  return (
    totalColorsCount > 0 && (
      <div
        className={`${productstyles.colorList} ${containerClass} ${
          isNewSwagmagicHost ? productstyles.colorListNew : ""
        }`}
      >
        {validColors.slice(0, colorsVisibleCount).map((color) => (
          <ToolTip
            key={`color-${color.presentation}`}
            isLightTheme
            disableOnResponsive
            content={color.presentation}
            arrow
            placement="top"
          >
            <span
              className={`${productstyles.colorOption} colorDotOption`}
              key={`color-${color.presentation}`}
              style={{
                backgroundColor: color.value || color,
              }}
            ></span>
          </ToolTip>
        ))}
        {renderOtherColorsCount()}
      </div>
    )
  );
};

export default ProductColorPills;
